<!--Banner-->
<ng-container *ngIf="name$ | async as name">
  <div class="d-lg-block d-none">
    <fgb-banner [title]="name"></fgb-banner>
  </div>
</ng-container>

<div class="d-block d-lg-none">
  <fgb-barcode [isHomePage]="true"></fgb-barcode>
</div>

<div class="widget-mobile">
  <fgbcl-scorecard-carousel [icon]="'chevron_right'" [showAllView]="true"></fgbcl-scorecard-carousel>

  <!--Featured Rewards-->
  <div class="container">
    <fgbcl-featured-rewards [showAllPath]="'/rewards'"></fgbcl-featured-rewards>
  </div>

  <!-- Campaign Offers -->
  <fgbcl-campaigns-offers-list [showAllOffers]="true"></fgbcl-campaigns-offers-list>

  <div class="container">
    <!-- Announcements -->
    <fgb-announcements></fgb-announcements>
  </div>
</div>
